import React from 'react';
interface DeviceFrameProps {
  children: React.ReactNode;
  label: string;
  /** Sizing utilities for the device. */
  sizeClassName?: string;
}

/** Phone hardware shell. The screen inside scrolls on its own. */
export function DeviceFrame({
  children,
  label,
  sizeClassName = 'h-[688px] w-[344px]'
}: DeviceFrameProps) {
  return <div role="group" aria-label={label} className={`relative shrink-0 rounded-[52px] bg-[#0A1622] p-[12px] shadow-[0_60px_110px_-50px_rgba(11,42,74,0.55)] ${sizeClassName}`} data-id="element-333" data-mp="3dq0ruaq0c63g">
      <span aria-hidden="true" className="absolute -left-[3px] top-[152px] h-14 w-[3px] rounded-l-full bg-[#0A1622]" data-id="element-334" data-mp="33uz5tnr13k53" />
      <span aria-hidden="true" className="absolute -left-[3px] top-[222px] h-14 w-[3px] rounded-l-full bg-[#0A1622]" data-id="element-335" data-mp="2pzwrcc848mgo" />
      <span aria-hidden="true" className="absolute -right-[3px] top-[186px] h-20 w-[3px] rounded-r-full bg-[#0A1622]" data-id="element-336" data-mp="2g3tqraswwvvu" />

      <div className="relative h-full w-full overflow-hidden rounded-[42px] bg-paper" data-id="element-337" data-mp="2l369bjcr3gsm">
        <span aria-hidden="true" className="absolute left-1/2 top-2.5 z-20 h-[18px] w-[78px] -translate-x-1/2 rounded-full bg-[#0A1622]" data-id="element-338" data-mp="a1tmqo92i0n5" />
        <div className="no-scrollbar flex h-full w-full flex-col overflow-y-auto overscroll-contain" data-id="element-339" data-mp="5533xt5voqy1">
          {children}
        </div>
      </div>
    </div>;
}